export const palette = {
    error: {
        main: '#FF0000',
        lighter: '#FFE5E5',
    },
    success: {
        main: '#1fc25d',
    },
    warning: {
        //main: '#f9fb93',
        main: '#ffa000',
    },
    primary: {
        dark: '#bf0000',
        main: '#FF0000',
        light: '#FF6666',
        lighter: '#FFE5E5',
        contrastText: '#ffffff',
    },
    secondary: {
        dark: '#3C3C3B',
        main: '#777777',
        light: '#E3E3E3',
        lighter: '#F2F2F2',
        contrastText: '#ffffff',
    },
    process_black: {
        main: '#000000',
        light: '#4C4C4C',
        lighter: '#999999',
        contrastText: '#ffffff',
        90: '#1A1A1A',
    },
    air_water: {
        dark: '#e54d12',
        main: '#ED6A1E',
        light: '#ED9849',
        lighter: '#FDE0C6',
        contrastText: '#ffffff',
    },
    air_air: {
        main: '#AF180E',
        light: '#D43C27',
        lighter: '#F49B8F',
        contrastText: '#ffffff',
    },
    tertiary_city_m: {
        main: '#1E8C9D',
        light: '#1EA6A1',
        lighter: '#C2FFFB',
        contrastText: '#ffffff',
    },
    tertiary_ice_cold_water: {
        main: '#005D95',
        light: '#006AB7',
        lighter: '#C2ECFF',
        contrastText: '#ffffff',
    },
    hyper_heating: {
        main: '#e06544',
        light: '#de967d',
        lighter: '#fdebdf',
    },
    zubadan: {
        main: '#9a3e91',
        light: '#ba9ec7',
        lighter: '#efe9f3',
    },
    power_inverter: {
        main: '#0298d7',
        light: '#00c0e7',
        lighter: '#e4f1fa',
    },
    neutral: {
        dark: '#000000',
        main: '#222222',
        light: '#cccccc',
        contrastText: '#ffffff',
        50: '#ffffff',
        100: '#f5f5f5',
        200: '#ebebeb',
        300: '#cccccc',
        400: '#aaaaaa',
        500: '#888888',
        600: '#666666',
        700: '#333333',
        800: '#222222',
        900: '#000000',
    },
    footer: {
        main: '#dbdbdb',
        light: '#e0e0e0',
    },
    icon: {
        main: '#706f6f',
    },
};
